import cloneDeep from 'lodash.clonedeep';

export const getFiltersFromSearchParams = (params, searchFilters) => {
    const dynamicParams = Object.keys(params);

    if (!Object.keys(params).length) {
        return {};
    }

    const filters = {
        ...dynamicParams.reduce((prev, currentKey) => {
            const filter = searchFilters?.data.children.find((filter) => filter.key === currentKey);
            if (filter) {
                const filterType = filter?.children?.type;
                if (filter.key === 'ctype') {
                    /* for filters of type ctype */
                    const newCtypeFilters = params[currentKey].split(',');
                    prev[currentKey] = new Set(newCtypeFilters);
                } else if (filterType === 'checkbox') {
                    // TODO: filters of type checkbox are not handled yet
                    prev[currentKey] = filter.items?.filter((item) =>
                        params[currentKey].split(',').includes(item.id || '')
                    );
                } else if (filterType === 'radio') {
                    prev[currentKey] = params[currentKey];
                }
            } else {
                /* for filters of type 'input' */
                let inputFilter = searchFilters?.data.children.find((filter) => {
                        return (filter?.children?.type === 'input') && filter?.children?.items?.some(item => item.name === currentKey);
                    }
                );

                if (inputFilter) {
                    prev[inputFilter.key] = {
                        ...(prev[inputFilter.key] || {}),
                        [currentKey]: params[currentKey]
                    };
                }
            }
            return prev;
        }, {})
    };

    return cloneDeep(filters);
};

export const getSearchParamsFromFilters = ({ filters, phrase }: { filters?: any, phrase: string }) => {
    let decoratedFilters = {};
    const noFiltersSet = !Object.keys(filters).length;

    if (!noFiltersSet) {
        decoratedFilters = Object.keys(filters).reduce((prev, currentKey) => {
            let newFilter;
            if (currentKey === 'ctype') {
                // for ctype filter
                newFilter = { ctype: [...(filters?.['ctype'] || [])].join(',') };
            } else if (typeof filters[currentKey] === 'object' && filters[currentKey]) {
                // for interval filters
                newFilter = Object.keys(filters[currentKey]).reduce((prev2, currentKey2) => ({
                    ...prev2,
                    [currentKey2]: filters[currentKey][currentKey2]
                }), {});
            } else {
                // for normal filters
                newFilter = { [currentKey]: filters[currentKey] };
            }

            return { ...prev, ...newFilter };
        }, {});
    }

    return new URLSearchParams({ text: phrase || '*', ...decoratedFilters }).toString();
};